export default __webpack_public_path__ + "static/media/10.f918eb40.jpg";